$(document).ready(function() {
    console.log( "DD DOM ready!" );  
  
  $(".cstm-pre-btn").on("click",function() {
    // if($( ".cl-po--option.hide").last().attr("data-option") == "Höhe Maß unten"){
    //   $("div[data-option|='Dimention']").removeClass("hide").addClass("active");
    //   $("div[data-option|='Höhe Maß oben']").removeClass("hide");
    //   $("div[data-option|='Höhe Maß unten']").removeClass("hide");
    // }else{
    // $( ".cl-po--option.hide").last().removeClass("hide").addClass("active");  
    // }    
    // ========Above code for back button step
    // console.log("click working");
    // var thisvalue = $(this).attr("data-pre");
    // console.log("dd-value" , thisvalue);
    // $( ".cl-po--option" ).each(function( index ) {
    //  console.log("this" , this);
    //   if ( $(this).attr('data-option') == thisvalue ) {
    //     console.log("only-this", this)
    //     $(this).show();
    //   }      
    // });
  });
$(".dd-app-section .add-to-cart").on( "click", function() {
  $( ".product-single__form .add-to-cart" ).trigger( "click" );
});
  
// $('.template_lpo-for-Window .pdp_atc_btn').hide();
// if($('.dd-inner-block') == ''){
//   $('.product-block').find('.pdp_atc_btn').show();
// }
  
$('.blog_post_slider').slick({
  slidesToShow: 3,
  slidesToScroll: 3,
  dots: true,
  arrows: false,
  responsive: [
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 481,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

if ($(window).width() < 769) {
  $('.fcollection_mobile_slider').slick({
    slidesToShow: 2,
    slidesToScroll: 2,
    dots: true,
    arrows: false
  });
}

setTimeout(function() {
  $('.rec_slider').slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    dots: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });
},1500);

// Note: Below code for PDP page Tab section 
$('.tabs-nav li:first-child').addClass('active');
$(function() {
  $('.tabs-nav a').click(function() {

    // Check for active
    $('.tabs-nav li').removeClass('active');
    $(this).parent().addClass('active');

    // Display active tab
    let currentTab = $(this).attr('href');
    $('.tabs-content div.inner-text').hide();
    $(currentTab).show();

    return false;
  });
});
// =====================================End of the code=================================
// Note: below code for FAQ page tabs
$('.faq-tabs-nav  li:first-child').addClass('active');
$(function() {
  $('.faq-tabs-nav a').click(function() {
    // Check for active
    $('.faq-tabs-nav li').removeClass('active');
    $(this).parent().addClass('active');
    // Display active tab
    let currentTab = $(this).attr('href');
    $('.faq-tabs-content div.inner-txt').hide();
    $(currentTab).show();
    return false;
  });
});
// =====================================================End of the code ============================================
// ==============NOte: below code for the blog load more button 
  $('.js-load-more').on('click', function(){
    // console.log("check-click")
    var $this =$(this),totalPages = parseInt($('[data-total-pages]').val()),currentPage = parseInt($('[data-current-page]').val());
    $this.attr('disabled', true);
    currentPage = currentPage+1;
    var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
    $('[data-current-page]').val(currentPage);

    $.ajax({
      url: nextUrl,
      type: 'GET',
      dataType: 'html',
      success: function(responseHTML){
        $('.dd-wrp-grid').append($(responseHTML).find('.dd-wrp-grid').html());
        // var gridlength = $("product-grid-item").length;
        // $(".current-pro").html(gridlength);
      },
      complete: function() {
        if(currentPage == totalPages) {
          $this.hide();
           // $this.attr('disabled', false); 
        }
      }
    })
  });
// ==================================cart drawer mandatory checkbox 
  //   $('.custom-check input').click(function() {
  //   if ($(this).is(':checked')) {
  //     $(".cart__checkout-wrapper button").removeAttr("disabled");
  //   }else{
  //      $(".cart__checkout-wrapper button").attr('disabled', 'true');
  //   }
  // });
  
// =============================================================
      // When Click on Search Icon Close Drawer Menu JS
      $('#NavDrawer .site-nav__link.site-nav__link--icon.js-search-header').click(function(){
      $('#NavDrawer .drawer__close-button.js-drawer-close').trigger('click');
      });
  
});


/****** theme custom pagenation Start ******/

function pagination_click_fun(){
  let loadMoreBtn = document.querySelector("[data-pagination-btn]") || null;
  if(loadMoreBtn){
    loadMoreBtn.addEventListener("click",function(e) {
      e.preventDefault();
      pagination_items_get_fun(loadMoreBtn);
    });
  }
}

if($('body').hasClass('template-blog')){
	if (window.location.href.includes('?page')){
		window.location.replace(window.location.href.split('?')[0]);
	}
}

pagination_click_fun();
function pagination_items_get_fun(loadMoreBtn){
  fetch(loadMoreBtn.getAttribute("href"))
  .then(response => {
  return response.text();
  })
  .then(response => {
    
    const parser = new DOMParser();
    const html = parser.parseFromString(response, "text/html");
    let proGrid = document.querySelector("[data-product-main-wrapper]");
    if(proGrid){
      // replace product grid HTML
      proGrid.innerHTML = document.querySelector("[data-product-main-wrapper]").innerHTML + html.querySelector("[data-product-main-wrapper]").innerHTML;
      // replace pagination HTML
      window.history.replaceState({}, null, loadMoreBtn.getAttribute("href")); // added curent pagination link
      let pagination = document.querySelector("[data-pagination-link]");
      let newPagination = html.querySelector("[data-pagination-link]");
      if(pagination && newPagination){
        pagination.innerHTML = newPagination.innerHTML;
        pagination_click_fun(); // reinit click event
      }
       // theme.reinitProductGridItem(); //this is theme defualt function
    }
  });
}
/****** theme custom pagenation End ******/